import { nameof } from "ts-simple-nameof";
import * as yup from "yup";
import { GeneralParamsDto } from "../dtos";

export const GeneralParamsValidationRuleObject = {
  [nameof<GeneralParamsDto>((x) => x.contractReplacementNumber)]: yup
    .string()
    .test(
      "no-whitespace",
      "Vyplňte číslo smlouvy",
      (value: string | undefined) => !value || !!value.trim()
    ),
  // SPOL
  [nameof<GeneralParamsDto>((x) => x.contractReplacementInsurerId)]: yup
    .number()
    .when(
      nameof<GeneralParamsDto>((x) => x.contractReplacementNumber),
      {
        is: (contractReplacementNumber?: string) => !!contractReplacementNumber,
        then: () =>
          yup
            .number()
            .nullable()
            .required("Vyberte pojišťovnu nahrazující smlouvy"),
        otherwise: () => yup.number().nullable().optional(),
      }
    ),
};

export const GeneralParamsValidationSchema = yup
  .object()
  .shape(GeneralParamsValidationRuleObject) as any;
